// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ArticlePreviewFragmentDoc } from './article-previews/ArticlePreview.fragment.generated';
export const ComponentArticlePreviewsFragmentDoc = gql`
    fragment componentArticlePreviews on ComponentArticlePreviews {
  articles(locale: $locale) {
    ...articlePreview
  }
}
    ${ArticlePreviewFragmentDoc}`;